import {
  Chart,
  ChartEvent,
  Interaction,
  InteractionItem,
  InteractionModeFunction,
  RadialLinearScale,
} from "chart.js";

declare module "chart.js" {
  interface InteractionModeMap {
    radarSector: InteractionModeFunction;
  }
}

const TAU = 2 * Math.PI;

/** Distance between two angles on the circle (0..π). */
const angleBetween = (a: number, b: number) => {
  const diff = Math.abs(a - b) % TAU;
  return diff > Math.PI ? TAU - diff : diff;
};

/**
 * Tooltip mode for the muscle radar: a tap anywhere picks the one spoke it points to.
 * "nearest" measured the distance to the points, and every 0 sits in the centre, so a tap
 * there tied them all and the tooltip listed each of them under one label.
 */
export const radarSectorMode: InteractionModeFunction = (chart: Chart, e: ChartEvent) => {
  const scale = chart.scales.r as RadialLinearScale | undefined;
  const points = chart.getDatasetMeta(0)?.data ?? [];
  if (!scale || !points.length || e.x === null || e.y === null) return [];

  // The scale's angles start at the top and run clockwise; so does this one (canvas y grows down).
  const tapAngle = Math.atan2(e.y - scale.yCenter, e.x - scale.xCenter) + Math.PI / 2;

  let closest = 0;
  points.forEach((_, index) => {
    if (
      angleBetween(tapAngle, scale.getIndexAngle(index)) <
      angleBetween(tapAngle, scale.getIndexAngle(closest))
    ) {
      closest = index;
    }
  });

  const item: InteractionItem = { element: points[closest], datasetIndex: 0, index: closest };
  return [item];
};

Interaction.modes.radarSector = radarSectorMode;
